import React, { createContext, useEffect } from "react";
import { useVersionedIndexedDBBackup } from "../../utils/useVersionedIndexedDbBackup";
import { DB_NAME, STORE_NAMES } from "../../App";

/* =======================================================
   Context
======================================================= */

const BackupContext = createContext(null);

/* =======================================================
   Provider
======================================================= */

export function BackupProvider({ children }) {
  const backup = useVersionedIndexedDBBackup(DB_NAME, STORE_NAMES);

  useEffect(() => {
    let mounted = true;

    async function initBackup() {
      await backup.loadBackupFile();

      if (!mounted) return;

      // Prompt user only once ever
      if (!backup.hasBackupFile && !backup.hasAskedToBackup()) {
        try {
          await backup.chooseBackupFile();
        } catch {
          // user cancelled — do nothing
        }
      }
    }

    initBackup();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <BackupContext.Provider value={backup}>
      {children}
    </BackupContext.Provider>
  );
}

/* =======================================================
   Class Component Support Helpers
======================================================= */

// Option A: Use contextType in class components
export { BackupContext };

// Option B: HOC if you prefer props injection
export function withBackup(Component) {
  return function WrappedComponent(props) {
    return (
      <BackupContext.Consumer>
        {backup => <Component {...props} backup={backup} />}
      </BackupContext.Consumer>
    );
  };
}